import React from "react";

import * as culori from "culori";
import { connect } from "react-redux";

import { getSiteColor } from "Common/Selectors";

export function hexToOKLCH(hex) {
  const parsedColor = culori.parse(hex);
  const oklchColor = culori.oklch(parsedColor);

  if (!oklchColor || oklchColor.l === undefined) {
    return "0.000 0.000 0.000";
  }

  const l = oklchColor.l?.toFixed(3) || "0.000";
  const c = oklchColor.c?.toFixed(3) || "0.000";
  const h = oklchColor.h?.toFixed(3) || "0.000";

  return `${l} ${c} ${h}`;
}

type State = {
  siteConfig: {
    color?: string;
    [key: string]: unknown;
  };
};

// Usage for LightenDarkenColor
// Lighten
// LightenDarkenColor("#F06D06", 20);
// Darken
// LightenDarkenColor("#F06D06", -20);
export function LightenDarkenColor(color, amount) {
  let usePound = false;

  if (color[0] == "#") {
    color = color.slice(1);
    usePound = true;
  }

  // Transform hexadecimal color to string of numbers
  const num = parseInt(color, 16);
  // Convert string of numbers to value and add amount
  let red = (num >> 16) + amount;
  let green = ((num >> 8) & 0x00ff) + amount;
  let blue = (num & 0x0000ff) + amount;

  // Adjust values so it's not over 255 or under 0
  if (red > 255) {
    red = 255;
  } else if (red < 0) {
    red = 0;
  }

  if (green > 255) {
    green = 255;
  } else if (green < 0) {
    green = 0;
  }

  if (blue > 255) {
    blue = 255;
  } else if (blue < 0) {
    blue = 0;
  }

  // Turn red, green, and blue colors back to hexadecimal
  const newColor = (red << 16) | (green << 8) | blue;
  return (usePound ? "#" : "") + newColor.toString(16).padStart(6, "0");
}

interface Props {
  color?: string;
}

export class ThemeInstallerUncontrolled extends React.Component<Props> {
  componentDidMount() {
    this.install(document, this.props.color);
  }

  componentDidUpdate() {
    this.install(document, this.props.color);
  }

  install(document, color) {
    const selector = `[site-color="${color}"]`;
    const styleTags = document.querySelectorAll(selector);

    if (styleTags.length > 0 || !color) {
      return;
    }

    const oklchColor = hexToOKLCH(color) || "0 0 0";

    const style = document.createElement("style");
    style.innerText = `:root {
    --primaryColor: ${color};
    --p: ${oklchColor};
    --primaryColorDarken10: ${LightenDarkenColor(color, -10)};
    --primaryColorDarken20: ${LightenDarkenColor(color, -20)};
    }`;
    style.setAttribute("site-color", color);
    document.body.appendChild(style);
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state: State, ownProps: Props) => ({
  color: getSiteColor(state) || ownProps.color,
});

export default connect(mapStateToProps)(ThemeInstallerUncontrolled);
